import axios from '../axios';

export const downloadAttachment = async (id: string, offerRequestId?: string | number): Promise<Blob> => {
  const params: Record<string, string> = { id };
  if (offerRequestId !== undefined && offerRequestId !== null) {
    params.offerRequestId = offerRequestId.toString();
  }
  const response = await axios.get('/json/attachments/download', {
    params,
    responseType: 'blob',
  });
  return response.data;
};

const AttachmentsService = {
  downloadAttachment,
};

export default AttachmentsService;
